import React, { useMemo } from 'react'

import { ModalDialog } from 'core-components/library/modalDialog'

import { FinalizeConfirmContent } from './FinalizeConfirmContent'

interface IProps {
  finalizeVersion: (saveData?: boolean) => void
  closeDialog: () => void
  show: boolean
  onlyConfirmation: boolean
}

export const FinalizeConfirmDialog = ({
  finalizeVersion,
  closeDialog,
  show,
  onlyConfirmation,
}: IProps) => {
  const contentProps = useMemo(
    () => ({
      finalizeVersion,
      onlyConfirmation,
    }),
    [onlyConfirmation, finalizeVersion]
  )
  return (
    <ModalDialog
      size={'xs'}
      content={FinalizeConfirmContent}
      contentProps={contentProps}
      show={show}
      closeOnOutsideClick={false}
      onClose={closeDialog}
    />
  )
}
